import { posthog } from 'posthog-js';

import {
  RemoteConfig,
  RemoteConfigDataStructure,
  RemoteConfigKey,
} from './types';
import { useIsFeatureFlagLoadedStore } from './useIsFeatureFlagLoaded';

const remoteConfigDataStructureMap: Record<
  RemoteConfigKey,
  RemoteConfigDataStructure
> = Object.freeze({
  [RemoteConfigKey.Announcement]: 'object',
});

export const getRemoteConfig = <Key extends RemoteConfigKey>(key: Key) => {
  if (!useIsFeatureFlagLoadedStore.getState().isLoaded) return;
  const remoteConfig = posthog.getFeatureFlagPayload(key);

  if (typeof remoteConfig === remoteConfigDataStructureMap[key]) {
    // cast type base on primitive type of the input, prevent unexpected remote config change induced runtime err
    return remoteConfig as RemoteConfig[Key];
  }
};
